import { reactive, computed } from '@vue/composition-api'
import * as apiProfile from '@/api/profile'
import { getDataURL } from '@/util/common'

export const ProfileChangeImage = (context) => {
  const store = context.root.$store
  const { profile } = store.state

  const file = reactive({
    loading: false,
    file: null,
    image: null,
    imagePath: 'ファイルを選択',

    // 設定ボタンクリック可能フラグ
    isSubmitButtonClickable: computed(() => {
      if (file.image) {
        return true
      } else {
        return false
      }
    }),

    // プレビュー時の処理
    setProfileImage: (ev) => {
      file.loading = true
      const files = ev.target.files || ev.dataTransfer.files
      file.file = files[0]
      file.image = null
      file.imagePath = file.file.name
      apiProfile
        .updateProfileImage(file.file, '1', profile.id)
        .then(res => {
          getDataURL(res).then((dataUrl) => {
            file.image = dataUrl
            file.loading = false
          })
        })
    },

    // 設定ボタン押下時の処理
    saveProfileImage: async (ev) => {
      if (file.isSubmitButtonClickable) {
        file.loading = true
        await apiProfile
          .updateProfileImage(file.file, '2', profile.id)
          .then((res) => {
            const { data } = res
            if (data && data.status === 0) {
              // プロフィールを取得
              store.dispatch('profile/fetch')
                .then((res) => {

                  // 利用者アイコンを取得
                  store.dispatch('profile/getUserImage')
                    .then((res) => {

                      store.dispatch('common/showToast', {text: 'プロフィール画像を更新しました。'})

                      file.loading = false
    
                      // ウィンドウを閉じる
                      context.emit('closeProfileChangeImage')
                    })
                })
            }
          })
      }
    },
    getImage: computed(() => (file.image) ?? profile.user_icon_image)
  })

  const close = () => {
    context.emit('closeProfileChangeImage')
  }

  return {
    profile,
    file,
    close
  }
}
